/**
 * Plazo para cobrar una factura anticipada o emitirle la Nota de Crédito: el
 * último día del MES EN QUE SE EMITIÓ. Pasado ese día queda fuera de término
 * (se sigue mostrando, como vencida).
 *
 * Todo en fechas calendario 'YYYY-MM-DD' de Argentina — sin horas, así un
 * "vence hoy" no se vuelve "vencida" a las 21:00 por el corrimiento a UTC.
 * Self-check: server/src/scripts/selfcheck-plazo-nc.ts
 */

/** Hoy en Argentina, 'YYYY-MM-DD'. */
export function hoyAr(now: Date = new Date()): string {
  return now.toLocaleDateString('en-CA', { timeZone: 'America/Argentina/Buenos_Aires' });
}

export type PlazoNc = {
  /** Último día del mes de emisión, 'YYYY-MM-DD'. */
  vence: string;
  /** Días hasta `vence`: 0 = vence hoy, negativo = vencida hace N días. */
  dias: number;
};

export function plazoNc(fechaEmision: string, hoy: string): PlazoNc | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(fechaEmision);
  const h = /^(\d{4})-(\d{2})-(\d{2})/.exec(hoy);
  if (!m || !h) return null;
  const anio = Number(m[1]);
  const mes = Number(m[2]);
  // Día 0 del mes siguiente = último día de este mes (UTC: sin DST de por medio).
  const ultimo = new Date(Date.UTC(anio, mes, 0));
  const hoyUtc = Date.UTC(Number(h[1]), Number(h[2]) - 1, Number(h[3]));
  return {
    vence: ultimo.toISOString().slice(0, 10),
    dias: Math.round((ultimo.getTime() - hoyUtc) / 86_400_000),
  };
}

/** "vence hoy" / "vence en 3 días" / "vencida hace 2 días". */
export function textoPlazo(p: PlazoNc): string {
  if (p.dias === 0) return 'vence hoy';
  if (p.dias > 0) return `vence en ${p.dias} día${p.dias === 1 ? '' : 's'}`;
  const n = -p.dias;
  return `vencida hace ${n} día${n === 1 ? '' : 's'}`;
}
